<div *ngIf="widget && dashboardId" class="card widget-card" [ngClass]="{'widget-card-small': isSmallWidget()}">
  <div *ngIf="isEditable" (click)="removeWidgetFromDashboard()"
       class="button badge error border-all border-c-white z-depth-1 c-white position-absolute"
       style="border-radius: 50%; border-width:3px; left: -8px; top: -8px; width:26px; height:26px; line-height:13px;z-index:1;">
    <span class="fas fa-minus"></span>
  </div>

  <ng-container *ngIf="resultState === 'SUCCESS' else spinnerOrError">
    <app-widget-bankproposal-large *ngIf="widget.widgetName === WidgetName.JDO && widget.size === 'LARGE'"
                                   [bankProposalData]="widgetData"
                                   [dashboardId]="dashboardId"
                                   [widget]="widget"
                                   (actionEvent)="trackAction($event)">
    </app-widget-bankproposal-large>
    <app-widget-bankproposal-small *ngIf="widget.widgetName === WidgetName.JDO && widget.size === 'SMALL'"
                                   [bankProposalData]="widgetData"
                                   [dashboardId]="dashboardId"
                                   [widget]="widget"
                                   (actionEvent)="trackAction($event)">
    </app-widget-bankproposal-small>
    <app-widget-simulation-small *ngIf="widget.widgetName === WidgetName.SIMULATION && widget.size === 'SMALL'"
                                 [simulationData]="widgetData"
                                 [dashboardId]="dashboardId"
                                 [widget]="widget"
                                 (actionEvent)="trackAction($event)">
    </app-widget-simulation-small>
    <app-widget-simulation-large *ngIf="widget.widgetName === WidgetName.SIMULATION && widget.size === 'LARGE'"
                                 [simulationData]="widgetData"
                                 [dashboardId]="dashboardId"
                                 [widget]="widget"
                                 [hideTitle]="isMocked"
                                 (actionEvent)="trackAction($event)">
    </app-widget-simulation-large>
    <app-widget-debt-summary *ngIf="widget.widgetName === WidgetName.DEBT_SUMMARY"
                             [debtSummary]="widgetData"
                             [widget]="widget"
                             (actionEvent)="trackAction($event)">
    </app-widget-debt-summary>
    <app-widget-guaranty *ngIf="widget.widgetName === WidgetName.GUARANTY"
                         [guarantyData]="widgetData"
                         [widget]="widget"
                         (actionEvent)="trackAction($event)">
    </app-widget-guaranty>
    <app-widget-debt-monthly-payments *ngIf="widget.widgetName === WidgetName.DEBT_MONTHLY_PAYMENTS"
                                      [debtMonthlyPayments]="widgetData"
                                      [widget]="widget"
                                      (actionEvent)="trackAction($event)">
    </app-widget-debt-monthly-payments>
    <app-widget-fundingtender *ngIf="widget.widgetName === WidgetName.YOUR_TENDER"
                              [tender]="widgetData"
                              [widget]="widget"
                              (actionEvent)="trackAction($event)">
    </app-widget-fundingtender>
    <app-widget-inviseo-variables *ngIf="INVISEO_VARIABLE_WIDGETS.indexOf(widget.widgetName) > -1"
                                  [inviseoVariablesExtraction]="widgetData"
                                  [widget]="widget"
                                  (actionEvent)="trackAction($event)">
    </app-widget-inviseo-variables>
    <app-widget-inviseo-scenarios-partages *ngIf="widget.widgetName === WidgetName.SCENARIOS_PARTAGES"
                                           [scenariosPartages]="widgetData"
                                           [widget]="widget"
                                           (actionEvent)="trackAction($event)">
    </app-widget-inviseo-scenarios-partages>
    <app-widget-publication-latest-videos-large *ngIf="widget.widgetName === WidgetName.LATEST_VIDEOS && widget.size === WidgetSize.LARGE"
                                                [widget]="widget"
                                                [articlesWithVideo]="widgetData"
                                                (actionEvent)="trackAction($event)">
    </app-widget-publication-latest-videos-large>
    <app-widget-publication-latest-videos-xlarge *ngIf="widget.widgetName === WidgetName.LATEST_VIDEOS && widget.size === WidgetSize.XLARGE"
                                                 [widget]="widget"
                                                 [articlesWithVideo]="widgetData"
                                                 (actionEvent)="trackAction($event)">
    </app-widget-publication-latest-videos-xlarge>
    <app-widget-publication-latest-articles *ngIf="widget.widgetName === WidgetName.LATEST_ARTICLES"
                                            [widget]="widget"
                                            [articles]="widgetData">
    </app-widget-publication-latest-articles>
    <app-widget-consultant-large *ngIf="widget.widgetName === WidgetName.DEDICATED_CONSULTANT  && widget.size === WidgetSize.LARGE"
                                 [widget]="widget"
                                 [portfolios]="widgetData"
                                 [isMocked]="isMocked">
    </app-widget-consultant-large>
    <app-widget-event-latest-event-xlarge *ngIf="widget.widgetName === WidgetName.LATEST_EVENTS && widget.size === WidgetSize.XLARGE"
                                          [widget]="widget"
                                          [solutionEvents]="widgetData"
                                          [isMocked]="isMocked">
    </app-widget-event-latest-event-xlarge>
  </ng-container>

  <ng-template #spinnerOrError>
    <div *ngIf="resultState === 'IN_PROGRESS'" class="widget-spinner"></div>
    <div *ngIf="resultState === 'ERROR'">
      <app-widget-message [message]="'service.non-available' | translate"
                          [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                          [widgetSize]="widget.size"
                          icone="far fa-alarm-clock"></app-widget-message>
    </div>
  </ng-template>
</div>
